import React from 'react'
import PropTypes from 'prop-types'
import ButtonContent from './button-content'
import StyledContent from './styled/content'
import Loading from '../loading/index'

const Content = (props) => {
  const {
    label = undefined,
    children = null,
    loading = false,
    style,
    // type = {},
    // opacityType,
    backgroundColor,
    textColor,
    className,
    icon,
  } = props
  if (loading) {
    return (
      <StyledContent className={className}>
        <Loading
          style={{ marginRight: '6px', width: '20px', height: '20px' }}
          color={(style && style.color) || textColor}
          backgroundColor={backgroundColor}
        />
        <ButtonContent label={label} icon={icon}>
          {children}
          {icon}
        </ButtonContent>
      </StyledContent>
    )
  }
  return (
    <ButtonContent label={label} icon={icon}>
      {children}
    </ButtonContent>
  )
}

Content.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
  // style: PropTypes.shape(PropTypes.object),
  className: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
}

Content.defaultProps = {
  icon: undefined,
  label: undefined,
  children: undefined,
  loading: false,
  // style: {},
  className: undefined,
  backgroundColor: undefined,
  textColor: undefined,
}

export default Content
